import { Component, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FeatureTrackingService } from '../../services/feature-tracking.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent implements OnInit {
  isMobile: boolean = false;
  isSmallScreen?: boolean = false;
  constructor(
    private translationLoader: FuseTranslationLoaderService,
    private deviceService: DeviceDetectorService,
    public translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private featureTracking: FeatureTrackingService,
  ) {
    this.translationLoader.loadTranslations(english, french);
  }

  ngOnInit(): void {
    this.featureTracking.trackFeature('visit-knowledge-base');
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe({
      next: (result) => {
        this.isSmallScreen = result.matches;
      },
    });
    this.isMobile = this.detectMobileDevice();
  }
  detectMobileDevice(): boolean {
    return this.deviceService.isMobile() || this.deviceService.isTablet();
  }
}
